module.exports = __webpack_public_path__ + "img/logo.c9122ea9.png";